import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { selectActiveTableRowsCount } from 'services/selectedTableCells/selectors';

interface ConnectedProps {
    activeTableRowsCount?: number;
}

type Props = ConnectedProps;

export class ActiveTableRowsCountValueComponent extends React.PureComponent<
    Props
> {
    render(): number | null {
        const { activeTableRowsCount } = this.props;

        if (!activeTableRowsCount) {
            return null;
        }

        return activeTableRowsCount;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    activeTableRowsCount: selectActiveTableRowsCount
});

export default connect(mapStateToProps)(ActiveTableRowsCountValueComponent);
